/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
export function jfFileDrop() {
    return {
        scope: {
            jfFileUploader: '=',
            jfFileDisabled: '=ngDisabled',
            addCallback: '&jfAddingFileCallback',
            showProgressBar: '='
        },
        restrict: 'E',
        templateUrl: 'directives/jf_file_drop/jf_file_drop.html',
        link: ($scope) => {
            $scope.jfFileUploader.onAfterAddingFile = (fileItem) => {
                $scope.jfFileUploader.queue = [fileItem];
                $scope.addCallback({fileItem: fileItem});
            }
        }
    }
}


// WEBPACK FOOTER //
// ./directives/jf_file_drop/jf_file_drop.js